module.exports = __webpack_public_path__ + "img/estimated-insurance-required-input.bd3dc202.svg";